import PromptBox from './PromptBox';
import ModelSelector from './ModelSelector';
import { IMAGE_MODEL_OPTIONS_EDIT } from '../../lib/imageModels';
import './ImageEditPromptBox.css';

/**
 * Shared prompt bar for keyframe image editing and org-asset image editing:
 * textarea + upload + Enhance + model + submit (via PromptBox).
 *
 * @param {boolean} [constrained=true] - When true, cap at 900px and center (keyframe + fullscreen asset). Embedded: false.
 */
function ImageEditPromptBox({
  value,
  onChange,
  onSubmit,
  isLoading = false,
  isEnhancing = false,
  placeholder,
  mentionableItems = [],
  uploadedImages,
  setUploadedImages,
  error,
  contentPolicyError,
  onContentPolicyRetry,
  onContentPolicyDismiss,
  submitDisabled,
  label,
  onMentionSelect,
  onMentionHover,
  showDragDrop = true,
  resizable = false,
  resizeMinHeight = 22,
  resizeDefaultHeight = 32,
  resizeMaxHeight = 220,
  className = '',
  imageModel,
  onImageModelChange,
  modelOptions = IMAGE_MODEL_OPTIONS_EDIT,
  modelSelectorDisabled = false,
  onEnhance,
  enhanceButtonDisabled = false,
  additionalActionsBelow = null,
  constrained = true,
}) {
  const rootClass = [
    'image-edit-prompt-box',
    constrained && 'image-edit-prompt-box--constrained',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <PromptBox
      value={value}
      onChange={onChange}
      onSubmit={onSubmit}
      isLoading={isLoading}
      isEnhancing={isEnhancing}
      placeholder={placeholder}
      mentionableItems={mentionableItems}
      uploadedImages={uploadedImages}
      setUploadedImages={setUploadedImages}
      error={error}
      contentPolicyError={contentPolicyError}
      onContentPolicyRetry={onContentPolicyRetry}
      onContentPolicyDismiss={onContentPolicyDismiss}
      submitDisabled={submitDisabled}
      label={label}
      onMentionSelect={onMentionSelect}
      onMentionHover={onMentionHover}
      showDragDrop={showDragDrop}
      resizable={resizable}
      resizeMinHeight={resizeMinHeight}
      resizeDefaultHeight={resizeDefaultHeight}
      resizeMaxHeight={resizeMaxHeight}
      className={rootClass}
      additionalActionsBelow={additionalActionsBelow}
      additionalActions={
        <>
          <button
            type="button"
            className="prompt-box-text-button"
            disabled={enhanceButtonDisabled}
            title="Enhance prompt"
            onClick={onEnhance}
          >
            {isEnhancing ? 'Enhancing…' : 'Enhance'}
          </button>
          <ModelSelector
            value={imageModel}
            onChange={onImageModelChange}
            disabled={modelSelectorDisabled}
            variant="compact"
            theme="neutral"
            options={modelOptions}
          />
        </>
      }
    />
  );
}

export default ImageEditPromptBox;
